import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-signup-bg-video',
  templateUrl: './auth-signup-bg-video.component.html',
  styleUrls: ['./auth-signup-bg-video.component.css']
})
export class AuthSignupBgVideoComponent {
  year = new Date().getFullYear()
}
